import type { Brand } from '@core/config-models';

export const OBSOLETE_ROOT_PLACEHOLDER = 'entry';

const LEGACY_PAGE_LAYOUT = '1c86d6a8-636b-51b1-b223-5e80fee4eee7';
const ESSENT_BLOG_PAGE_LAYOUT = '51ac9f44-46b6-4e79-8c17-6339d7dcafd4';
const ESSENT_CAMPAIGN_PAGE_LAYOUT = 'abb5b64c-394a-45bb-a142-194fc068e2ea';
const ESSENT_DETAIL_PAGE_LAYOUT = '926afbbb-62ea-437e-8619-b1ba8900e182';
const ESSENT_FUNNEL_PAGE_LAYOUT = '761804f2-18d4-4ddc-b4d0-ad2d13c5dbd1';
const ESSENT_HOME_PAGE_LAYOUT = '934d5cc4-1d29-4bcd-86ad-b01bdcf7e631';
const ESSENT_OVERVIEW_PAGE_LAYOUT = '7a6d2cda-66cd-4d7a-9f89-b76eab176040';
const ESSENT_PRODUCT_PAGE_LAYOUT = '356bedd2-0abc-44e4-bf08-a9d9473971f4';
const ESSENT_SERVICE_PAGE_LAYOUT = 'd82c9c18-1206-466e-b533-a58b29730ae5';

const ENERGIEDIRECT_BLOG_PAGE_LAYOUT = '34f481d6-336a-4908-9cd0-44317bd57c40';
const ENERGIEDIRECT_CAMPAIGN_PAGE_LAYOUT =
  '2cce4d3f-6829-4b58-852e-836615fb4d4c';
const ENERGIEDIRECT_DETAIL_PAGE_LAYOUT = 'd6663b12-13ca-4776-af3c-ec777b8dead0';
const ENERGIEDIRECT_FUNNEL_PAGE_LAYOUT = '2d0ac760-6241-48f9-b807-b30f23e20675';
const ENERGIEDIRECT_HOME_PAGE_LAYOUT = '9be63b7f-b289-454b-9c19-ca5aa16a22ae';
const ENERGIEDIRECT_OVERVIEW_PAGE_LAYOUT =
  '6a8b842c-8ce2-4d1a-b4b6-0fcfd0a2611d';
const ENERGIEDIRECT_PRODUCT_PAGE_LAYOUT =
  'f2907442-1844-4eb6-bacf-5401e52ed887';
const ENERGIEDIRECT_SERVICE_PAGE_LAYOUT =
  '1af774be-6def-4824-955a-6971032fec16';

type Category =
  | 'home'
  | 'campaign'
  | 'blog'
  | 'detail'
  | 'funnel'
  | 'overview'
  | 'product'
  | 'service';

const buildLayout = (
  category: Category,
  brand: Brand,
  { includeFaq = true, includeBreadcrumbs = true, includeUsp = false } = {}
) => {
  return [
    'notification',
    ...(includeBreadcrumbs ? ['breadcrumb'] : []),
    `${category}_hero_${brand}`,
    ...(includeUsp ? ['usp'] : []),
    `${category}_content_${brand}`,
    ...(includeFaq ? ['faq'] : []),
    'footer',
  ];
};

export const layouts = {
  [LEGACY_PAGE_LAYOUT]: [OBSOLETE_ROOT_PLACEHOLDER],
  [ESSENT_BLOG_PAGE_LAYOUT]: buildLayout('blog', 'essent'),
  [ESSENT_CAMPAIGN_PAGE_LAYOUT]: buildLayout('campaign', 'essent', {
    includeFaq: false,
    includeUsp: true,
    includeBreadcrumbs: false,
  }),
  [ESSENT_DETAIL_PAGE_LAYOUT]: buildLayout('detail', 'essent'),
  [ESSENT_HOME_PAGE_LAYOUT]: buildLayout('home', 'essent', {
    includeFaq: false,
    includeBreadcrumbs: false,
  }),
  [ESSENT_FUNNEL_PAGE_LAYOUT]: buildLayout('funnel', 'essent', {
    includeFaq: false,
    includeBreadcrumbs: false,
  }),
  [ESSENT_OVERVIEW_PAGE_LAYOUT]: buildLayout('overview', 'essent', {
    includeUsp: true,
  }),
  [ESSENT_PRODUCT_PAGE_LAYOUT]: buildLayout('product', 'essent', {
    includeUsp: true,
  }),
  [ESSENT_SERVICE_PAGE_LAYOUT]: buildLayout('service', 'essent', {
    includeFaq: false,
  }),
  [ENERGIEDIRECT_BLOG_PAGE_LAYOUT]: buildLayout('blog', 'energiedirect'),
  [ENERGIEDIRECT_CAMPAIGN_PAGE_LAYOUT]: buildLayout(
    'campaign',
    'energiedirect',
    {
      includeFaq: false,
      includeUsp: true,
      includeBreadcrumbs: false,
    }
  ),
  [ENERGIEDIRECT_DETAIL_PAGE_LAYOUT]: buildLayout('detail', 'energiedirect'),
  [ENERGIEDIRECT_HOME_PAGE_LAYOUT]: buildLayout('home', 'energiedirect', {
    includeFaq: false,
    includeBreadcrumbs: false,
  }),
  [ENERGIEDIRECT_FUNNEL_PAGE_LAYOUT]: buildLayout('funnel', 'energiedirect', {
    includeFaq: false,
    includeBreadcrumbs: false,
  }),
  [ENERGIEDIRECT_OVERVIEW_PAGE_LAYOUT]: buildLayout(
    'overview',
    'energiedirect',
    {
      includeUsp: true,
    }
  ),
  [ENERGIEDIRECT_PRODUCT_PAGE_LAYOUT]: buildLayout('product', 'energiedirect', {
    includeUsp: true,
  }),
  [ENERGIEDIRECT_SERVICE_PAGE_LAYOUT]: buildLayout('service', 'energiedirect', {
    includeFaq: false,
  }),
};
